export const setFocus = (selector: string, tabIndex:  number|null = null) => {
  const $element = $(selector);
  if (tabIndex !== null) {
    $element.attr('tabindex', tabIndex);
  }

  $element.trigger('focus');
};

export const moveFocusToElement = (
  index: number,
  step: 1|-1,
  itemsCount: number,
  createSelector: (selectedIndex: number) => string
): number => {
  const indexToMove = index + step;
  let selectedIndex = 0;
  if (indexToMove < 0) {
    selectedIndex = itemsCount - 1;
  } else if (indexToMove === itemsCount) {
    selectedIndex = 0;
  } else {
    selectedIndex = indexToMove;
  }

  const selector: string = createSelector(selectedIndex);
  setFocus(selector);

  return selectedIndex;
}
